<div
  class="p-2 mb-3 bg-third-level rounded-sm flex flex-wrap xl:flex-nowrap items-center gap-2 w-full min-w-0"
  [attr.data-testid]="'function-row-' + functionEntry().directusId"
>
  <div class="flex items-center gap-2 w-full xl:w-64 shrink-0 min-w-0">
    @if (functionEntry().isInProjectScope) {
      <div class="w-2 h-2 bg-primary rounded-full shrink-0"></div>
    } @else {
      <div class="w-2 h-2 shrink-0"></div>
    }
    <app-module-function-label
      class="truncate flex-1 min-w-0"
      [translations]="functionEntry().translations!"
    />
  </div>

  <div class="flex-1 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-2 min-w-0 w-full">
    <div class="w-full min-w-0">
      <app-model-field-select
        [id]="'planned-action-' + functionEntry().directusId"
        [options]="plannedActionOptions()"
        optionLabel="label"
        optionValue="value"
        placeholder="project.steps.systemRecording.plannedAction.placeholder"
        [value]="functionEntry().plannedAction"
        (valueChange)="onPlannedActionChange($event)"
        [showClear]="false"
        [disabled]="isReadOnly()"
      />
    </div>

    <div class="w-full min-w-0">
      <app-model-field-autocomplete
        #providerAutocomplete
        [value]="providerDisplayValue()"
        (valueChange)="onProviderChange($event)"
        [suggestions]="filteredProviders()"
        (inputChange)="onProviderSearch($event)"
        (dropdownOpen)="onProviderDropdownClick()"
        placeholder="project.steps.systemRecording.provider.placeholder"
        optionLabel="providerName"
        itemIdField="providerId"
        [testId]="'provider-autocomplete-' + functionEntry().directusId"
        addButtonLabel="project.steps.systemRecording.providers.addButton.text"
        [addButtonDisabled]="isAddProviderDisabled()"
        [isCustom]="isCustomProvider"
        [disabled]="
          functionEntry().plannedAction === PlannedAction.NEW ||
          functionEntry().plannedAction === PlannedAction.NO_SYSTEM ||
          !functionEntry().plannedAction ||
          isSyncingProvider() ||
          isReadOnly()
        "
        (add)="onAddNewProvider()"
        (deleteItem)="onDeleteProvider($event)"
      />
    </div>

    <div class="w-full min-w-0">
      <app-model-field-autocomplete
        #toolAutocomplete
        [value]="toolDisplayValue()"
        (valueChange)="onToolChange($event)"
        [suggestions]="filteredTools()"
        (inputChange)="onToolSearch($event)"
        (dropdownOpen)="onToolDropdownClick()"
        placeholder="project.steps.systemRecording.tool.placeholder"
        optionLabel="toolName"
        [testId]="'tool-autocomplete-' + functionEntry().directusId"
        addButtonLabel="project.steps.systemRecording.tools.addButton.text"
        [addButtonDisabled]="isAddToolDisabled()"
        [isCustom]="isCustomTool"
        [disabled]="
          functionEntry().plannedAction === PlannedAction.NEW ||
          functionEntry().plannedAction === PlannedAction.NO_SYSTEM ||
          !currentFunctionEntry()?.providerId ||
          isReadOnly()
        "
        (add)="onAddNewTool()"
        (deleteItem)="onDeleteTool($event)"
      />
    </div>

    <div class="w-full min-w-0">
      <app-office-multi-select
        [projectId]="projectId()"
        [selectedOffices]="functionEntry().selectedOffices"
        [isReadOnly]="isReadOnly()"
        (selectionChange)="onOfficeSelectionChange($event)"
      />
    </div>
  </div>

  @if (hasMultipleOffices()) {
    <div class="flex items-center gap-1 shrink-0 justify-end min-w-20 ml-auto xl:ml-0">
      <p-button
        icon="pi pi-plus"
        severity="secondary"
        size="small"
        (onClick)="onAddInstance()"
        [disabled]="isReadOnly()"
        [attr.title]="'project.steps.systemRecording.addInstance.title' | transloco"
      />

      @if (hasDuplicates()) {
        <p-button
          icon="pi pi-trash"
          severity="danger"
          size="small"
          (onClick)="onRemoveInstance()"
          [disabled]="isReadOnly()"
          [attr.title]="'project.steps.systemRecording.removeInstance.placeholder' | transloco"
        />
      } @else {
        <div class="w-8 h-8 shrink-0"></div>
      }
    </div>
  }
</div>
